import { AccountingFormTypes } from "models/formTypes";
import { DateRange } from "models/formTypes/util";

// Matches the local-time yyyy-MM that monthRangeQueryEncoder writes via the overridden Date.toJSON.
const toYearMonth = (date: Date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;

// Only the period means the same thing on every tab; tags, comparison columns and dimension types do not.
// A period in the URL also makes the next tab skip its saved default filter, so the default period, which every
// tab would pick anyway, does not travel.
export function getPeriodSearch(search: string, monthRangeName: string, defaultRange?: DateRange): string {
  const current = new URLSearchParams(search);
  const startName = `${monthRangeName}Start`;
  const endName = `${monthRangeName}End`;
  const start = current.get(startName);
  const end = current.get(endName);

  if (start == null || end == null) return "";

  if (
    defaultRange?.start &&
    defaultRange?.end &&
    start === toYearMonth(defaultRange.start) &&
    end === toYearMonth(defaultRange.end)
  )
    return "";

  const kept = new URLSearchParams();
  kept.set(startName, start);
  kept.set(endName, end);
  return `?${kept.toString()}`;
}

// A period carried over from another tab puts filter params in the URL, which makes the filter context skip the
// tag tab's initial filter, so its defaults are filled in here for whatever the URL leaves out.
export function withTagReportDefaults(
  pageFilter: AccountingFormTypes.FinancialReportFilter | undefined,
  defaults: AccountingFormTypes.FinancialReportFilter
): AccountingFormTypes.FinancialReportFilter {
  const merged: Record<string, unknown> = { ...defaults };

  for (const [key, value] of Object.entries(pageFilter ?? {})) {
    if (value !== undefined) merged[key] = value;
  }

  if (!(pageFilter?.monthRange?.start && pageFilter?.monthRange?.end)) merged.monthRange = defaults.monthRange;

  return merged as AccountingFormTypes.FinancialReportFilter;
}
